import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Shield, TrendingUp, Home } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';

const WhatWeDoPage = () => {
  const services = [
    {
      icon: Shield,
      title: "Insurance Solutions",
      description: "Life, health, critical illness, disability, and other protection strategies designed to safeguard what matters most.",
      link: "/insurance",
      iconColor: "text-[#0077B6]",
      bgColor: "bg-[#0077B6]/10",
      borderColor: "border-[#0077B6]"
    },
    {
      icon: TrendingUp,
      title: "Investment & Wealth Strategies",
      description: "Long-term planning and investment solutions built around your goals, risk tolerance, and life stage.",
      link: "/investment",
      iconColor: "text-[#D4AF37]",
      bgColor: "bg-[#D4AF37]/10",
      borderColor: "border-[#D4AF37]"
    },
    {
      icon: Home,
      title: "Mortgage Solutions",
      description: "Mortgage services are offered under our trade name, Dominion Lending Centres Utmost Financial, giving clients access to a wide range of lenders, products, and competitive financing options.",
      link: "/mortgage",
      iconColor: "text-[#0077B6]",
      bgColor: "bg-[#0077B6]/10",
      borderColor: "border-[#0077B6]"
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative h-[350px] flex items-center justify-center overflow-hidden bg-[#0077B6]">
        <div className="absolute inset-0 bg-gradient-to-b from-[#0077B6] to-[#005A8C]" />
        <div className="relative z-10 max-w-4xl mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-3 text-white">What We Do</h1>
          <p className="text-lg text-blue-100">
            A holistic approach to financial planning
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-12">
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Utmost Financial Inc. offers a holistic approach to financial planning, focusing on <span className="font-bold text-[#0077B6]">protection</span>, <span className="font-bold text-[#D4AF37]">growth</span>, and <span className="font-bold text-[#0077B6]">long-term stability</span>.
            </p>
            <div className="h-1 w-24 bg-[#D4AF37] mx-auto mt-6"></div>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {services.map((service) => (
              <Link key={service.link || service.title} to={service.link}>
                <Card className="h-full bg-[#F0F7FF] border border-blue-100 hover:border-[#0077B6] transition-all duration-300 hover:-translate-y-1 hover:shadow-lg">
                  <CardContent className="p-6">
                    <div className={`w-16 h-16 rounded-xl ${service.bgColor} border-2 ${service.borderColor} flex items-center justify-center mb-5`}>
                      <service.icon className={`h-8 w-8 ${service.iconColor}`} />
                    </div>
                    <h3 className="text-xl font-bold text-gray-800 mb-3">{service.title}</h3>
                    <p className="text-gray-600 leading-relaxed">{service.description}</p>
                  </CardContent>
                </Card>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 bg-[#0077B6]">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-white mb-3">Ready to Get Started?</h2>
          <p className="text-blue-100 mb-6 text-lg">
            Let our team help you build a comprehensive financial plan tailored to your needs.
          </p>
          <Button asChild size="lg" className="bg-[#D4AF37] hover:bg-[#B8962E] text-[#003D5C] font-bold text-lg px-8">
            <Link to="/team">Meet Our Team</Link>
          </Button>
        </div>
      </section>
    </div>
  );
};

export default WhatWeDoPage;
